import type { App } from 'vue';
import { useAuth } from '@/hooks/business/auth';
/**
 * 权限指令 v-auth="sys:account:add"
 *
 * @param app APP
 */
export function authDirective(app: App) {
  const { hasAuth } = useAuth();
  app.directive('auth', {
    // 在元素被插入到 DOM 中时触发
    beforeMount(el, binding) {
      // 如果绑定值为 false，则从父节点中移除元素
      if (!hasAuth(binding.value)) {
        el.parentNode.removeChild(el);
      }
    },
    beforeUpdate(el, binding) {
      if (!hasAuth(binding.value)) {
        el.parentNode.removeChild(el);
      }
    }
  });
}
